import Footer from '../components/Footer.jsx';
import PublicHeader from '../components/PublicHeader.jsx';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';

export default function Terms() {
  useTitle('Terms of Service');
  useMetaTags({
    description: 'TrainForge terms of service: account rules, fitness liability waiver, and how AI-generated workout and nutrition suggestions should be treated.',
    ogTitle: 'TrainForge terms of service',
    ogDescription: 'Account rules, fitness liability waiver, and AI-generated content disclaimers.',
    ogType: 'website',
    canonical: 'https://mytrainforge.com/terms',
  });
  return (
    <div>
      <PublicHeader />
      <div className="shell" style={{ maxWidth: 640 }}>
      <h1>Terms of Service</h1>
      <div style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--text-dim)' }}>
        <p>By using this application ("TrainForge"), you agree to these terms. TrainForge is provided by the gym and its technology partner. You must be 16 or older to use the service. You are responsible for maintaining the security of your account credentials.</p>
        <p>We reserve the right to suspend or terminate accounts that violate these terms or engage in abusive behavior toward other members, trainers, or staff.</p>

        <h2 style={{ color: 'var(--text)' }}>Fitness Liability Waiver</h2>
        <p><b>ASSUMPTION OF RISK:</b> I understand that physical exercise involves inherent risks of injury. I voluntarily assume full responsibility for any risks of loss, property damage, or personal injury that may be sustained as a result of participating in any exercise program, whether suggested by this app, a trainer, or an AI system.</p>
        <p><b>RELEASE OF LIABILITY:</b> I release and hold harmless the gym, its owners, trainers, technology partners, and affiliates from any and all liability for injuries, damages, or losses arising from my use of this application or participation in any exercise program.</p>
        <p><b>MEDICAL CLEARANCE:</b> I confirm that I have consulted with a qualified physician and have been cleared for physical activity, or I accept full responsibility for exercising without such clearance.</p>

        <h2 style={{ color: 'var(--text)' }}>AI-Generated Content</h2>
        <p>Workout programs, daily check-ins, macro suggestions, and nutrition estimates generated by AI are algorithmic suggestions. They are <b>not</b> professional medical, fitness, or nutritional advice. Food photo calorie estimates are approximate (±25%). Always consult qualified professionals for medical conditions, injuries, allergies, or dietary needs.</p>

        <h2 style={{ color: 'var(--text)' }}>Food Allergy Disclaimer</h2>
        <p>AI-generated meal suggestions are not guaranteed to detect or avoid allergens. Always verify ingredients independently if you have severe food allergies.</p>

        <p style={{ color: 'var(--text-muted)', marginTop: 32, fontSize: 11 }}>Terms version 2 · Last updated May 2026</p>
      </div>
      <Footer />
      </div>
    </div>
  );
}
